import React from "react";
import ReactHOC from "../../../../common/react-hoc";
import { registerEqualHeight } from "../../../../../../../wdh-foundation/wdh";
import { resolveImageSrc } from "@demant/wdh";
import { FlexComponentBootstrap } from "../../../../common/component-bootstraper";
import { addTrackingToProductClick } from "../../../../../js/feature/gtm-tracking";

class DefaultImageSpotApp extends React.Component {
  constructor(props) {
    super(props);

    this.imageSpotList = this.props.settings.imageSpotList;
  }

  componentDidMount() {
    registerEqualHeight(
      this.props.$component[0].querySelectorAll(".image-spot-element-header")
    );
    registerEqualHeight(
      this.props.$component[0].querySelectorAll(".image-spot-element-text")
    );
  }

  checkIfEmptyString(el) {
    const withoutSpace = el.trim().replace("&nbsp;", "");
    return withoutSpace.length > 0;
  }

  render() {
    return (
      <React.Fragment>
        <ul
          className={`image-spot-elements elements-${this.imageSpotList.length}`}
        >
          {this.imageSpotList.map((item, index) => {
            const imgSrc = item.image ? resolveImageSrc(item.image) : "";
            return (
              <li className="image-spot-element" key={index}>
                {item.image && (
                  <div className="image-spot-element-image">
                    <img
                      src={imgSrc}
                      alt={item.image.alt}
                      width={item.image.width}
                      height={item.image.height}
                    />
                    {item.imageDescription && (
                      <p
                        className="image-spot-element-image-description"
                        dangerouslySetInnerHTML={{
                          __html: item.imageDescription
                        }}
                      />
                    )}
                  </div>
                )}
                {item.header && this.checkIfEmptyString(item.header) && (
                  <div
                    className="image-spot-element-header"
                    dangerouslySetInnerHTML={{ __html: item.header }}
                  />
                )}
                {item.text && this.checkIfEmptyString(item.text) && (
                  <div
                    className="image-spot-element-text"
                    dangerouslySetInnerHTML={{ __html: item.text }}
                  />
                )}
                {item.contextContent && (
                  <div className="image-spot-element-context">
                    <div
                      className="image-spot-element-context-content"
                      dangerouslySetInnerHTML={{ __html: item.contextContent }}
                    />
                  </div>
                )}
                {item.link && (
                  <div className="image-spot-element-link">
                    <a
                      href={item.link.href}
                      className={item.link.class}
                      onClick={e =>
                        addTrackingToProductClick(
                          e,
                          item.link.href,
                          item.link.target,
                          "button_click"
                        )
                      }
                    >
                      {item.link.content}
                    </a>
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      </React.Fragment>
    );
  }
}

const defaultImageSpot = new FlexComponentBootstrap(
  "image-spot",
  ":not(.accordion-img-as-tab):not(.buttons-container):not(.as-carousel):not(.side-accordion)"
);
defaultImageSpot.reactApp = ReactHOC(DefaultImageSpotApp);
defaultImageSpot.run();
